import { TextField as MuiTextField, Pagination as MuiPagination, styled } from '@mui/material';

export const TextField = styled(MuiTextField)(() => ({
  '& .Mui-focused': {
    borderColor: 'white',
  },
  'input::-webkit-inner-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0,
  },
  'input::-webkit-outer-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0,
  },
  '& .MuiInputBase-input': {
    color: 'white',
    borderColor: 'white',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'white',
    ':hover': { borderColor: 'white' },
    ':focus': { borderColor: 'white' },
    '&.Mui-focused': { borderColor: 'white' },
  },
  '& fieldset': {
    borderColor: 'white !important',
  },
  maxWidth: 130,
}));

export const Pagination = styled(MuiPagination)(() => ({
  '.MuiPaginationItem-page': { color: 'white' },
  '.Mui-selected': { backgroundColor: '#ffffff14 !important' },
  '.MuiPaginationItem-previousNext': { color: 'white' },
  '.MuiPaginationItem-ellipsis': { color: 'white' },
  input: { color: 'white' },
}));
